import { validMoveRecordCharSet } from "../utils/move.utils";

export const convertSimpleRecordToMovelist = (input?: Sometimes<string>) => {
  return input?.match(new RegExp(`[${validMoveRecordCharSet}]+`, "g"));
};
